module.exports = __webpack_public_path__ + "static/media/view.7e6e0b3f.svg";